import { render, staticRenderFns } from "./moblieScreen.vue?vue&type=template&id=8fb459ce&scoped=true"
import script from "./moblieScreen.vue?vue&type=script&lang=js"
export * from "./moblieScreen.vue?vue&type=script&lang=js"
import style0 from "./moblieScreen.vue?vue&type=style&index=0&id=8fb459ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb459ce",
  null
  
)

export default component.exports